import './style/index.less';
import IconFont from './IconFont';

export default IconFont;
